export default {
  select: {
    method: 'get',
    url: '/commodity/category/find?key=KEY'
  }
}
